import { Theme, useTheme } from '@mui/material/styles';
import { Box, SxProps, useMediaQuery } from '@mui/material';
import { forwardRef } from 'react';

type ReportContentWrapperProps = {
  children: React.ReactNode;
  theme?: Theme;
  sx?: SxProps<Theme>;
};

const ReportContentWrapper = forwardRef(
  ({ children, theme, sx }: ReportContentWrapperProps, ref) => {
    const siteTheme = useTheme();
    theme = theme ?? siteTheme;
    const isMobile = useMediaQuery(siteTheme.breakpoints.down('xl'));

    return (
      <Box
        sx={{
          flexGrow: '2',
          minHeight: '100%',
          overflow: 'auto',
          padding: isMobile ? '8px' : '16px',
          color: `${theme.palette.text.primary} !important`,
          backgroundColor: `${theme.palette.background.default} !important`,
          ...sx,
        }}
        ref={ref}
      >
        {children}
      </Box>
    );
  },
);

export default ReportContentWrapper;
